function TaskForm({
  newTask,
  setNewTask,
  dueDate,
  setDueDate,
  taskTime,
  setTaskTime,
  statusId,
  setStatusId,
  projectId,
  setProjectId,
  priorityId,
  setPriorityId,
  contextId,
  setContextId,
  focusAreaId,
  setFocusAreaId,
  locationId,
  setLocationId,
  notes,
  setNotes,
  timeOfDayId,
  setTimeOfDayId,
  impactId,
  setImpactId,
  capacityId,
  setCapacityId,
  dayTypeId,
  setDayTypeId,
  taskTimes,
  statusLevels,
  projects,
  priorityLevels,
  contexts,
  focusAreas,
  locations,
  timeOfDayLevels,
  impactLevels,
  capacityLevels,
  dayTypeLevels,
  editingTaskId,
  addTask,
  saveTaskEdits,
  resetTaskForm
}) {

  return (
    <>
    {/* Row 1 - Task Name, Due Date, Task Time, Status */}
<div style={{
  display: 'flex',
  gap: '10px',
  flexWrap: 'wrap',
  marginBottom: '12px'
}}>
  <input
    type="text"
    placeholder="New task..."
    value={newTask}
    onChange={(e) => setNewTask(e.target.value)}
    onKeyDown={(e) => e.key === 'Enter' && addTask()}
    style={{ minWidth: '260px' }}
  />

  <input
    type="date"
    value={dueDate}
    onChange={(e) => setDueDate(e.target.value)}
  />

  <select
    value={taskTime}
    onChange={(e) => setTaskTime(e.target.value)}
  >
    <option value="">Task Time</option>
    {taskTimes.map(t => (
      <option key={t.id} value={t.id}>
        {t.name}
      </option>
    ))}
  </select>

   <select value={statusId} onChange={(e) => setStatusId(e.target.value)}>
    <option value="">Status</option>
    {statusLevels
      .slice()
      .sort((a, b) => a.sort_order - b.sort_order)
      .map(item => (
        <option key={item.id} value={item.id}>
          {item.name}
        </option>
      ))}
  </select>

</div>

{/* Row 2 - Project, Importance-Consistency Value, Context, Focus Area, Location */}
<div style={{
  display: 'flex',
  gap: '10px',
  flexWrap: 'wrap',
  marginBottom: '12px'
}}>
  <select value={projectId} onChange={(e) => setProjectId(e.target.value)}>
    <option value="">Project</option>
    {projects
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(project => (
        <option key={project.id} value={project.id}>
          {project.name}
        </option>
      ))}
  </select>

  <select value={priorityId} onChange={(e) => setPriorityId(e.target.value)}>
    <option value="">Value</option>
    {priorityLevels.map(item => (
      <option key={item.id} value={item.id}>
        {item.name}
      </option>
    ))}
  </select>

  <select value={contextId} onChange={(e) => setContextId(e.target.value)}>
    <option value="">Context</option>
    {contexts
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(context => (
        <option key={context.id} value={context.id}>
          {context.name}
        </option>
      ))}
  </select>

  <select
    value={focusAreaId}
    onChange={(e) => setFocusAreaId(e.target.value)}
  >
    <option value="">Focus Area</option>
    {focusAreas
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(area => (
        <option key={area.id} value={area.id}>
          {area.name}
        </option>
      ))}
  </select>

  <select
    value={locationId}
    onChange={(e) => setLocationId(e.target.value)}
  >
    <option value="">Location</option>
    {locations
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(location => (
        <option key={location.id} value={location.id}>
          {location.name}
        </option>
      ))}
  </select>
</div>

{/* Row 3 - Daily Flow, Impact, Capacity, Day Type */}
<div style={{
  display: 'flex',
  gap: '10px',
  flexWrap: 'wrap',
  marginBottom: '12px'
}}>
  <select
    value={timeOfDayId}
    onChange={(e) => setTimeOfDayId(e.target.value)}
  >
    <option value="">Daily Flow</option>
    {timeOfDayLevels.map(item => (
      <option key={item.id} value={item.id}>
        {item.name}
      </option>
    ))}
  </select>

  <select value={impactId} onChange={(e) => setImpactId(e.target.value)}>
    <option value="">Impact</option>
    {impactLevels.map(item => (
      <option key={item.id} value={item.id}>
        {item.name}
      </option>
    ))}
  </select>

  <select value={capacityId} onChange={(e) => setCapacityId(e.target.value)}>
    <option value="">Capacity</option>
    {capacityLevels.map(item => (
      <option key={item.id} value={item.id}>
        {item.name}
      </option>
    ))}
  </select>

  <select value={dayTypeId} onChange={(e) => setDayTypeId(e.target.value)}>
    <option value="">Day Type</option>
    {dayTypeLevels.map(item => (
      <option key={item.id} value={item.id}>
        {item.name}
      </option>
    ))}
  </select>
</div>

{/* Row 4 - Notes */}
<input
  value={notes}
  onChange={(e) => setNotes(e.target.value)}
  placeholder="Notes..."
  style={{
    width: '100%',
    marginBottom: '12px'
  }}
/>

<div
  style={{
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  }}
>
  <button onClick={editingTaskId ? saveTaskEdits : addTask}>
    {editingTaskId ? 'Save Changes' : 'Add Task'}
  </button>

  {editingTaskId && (
    <button
      onClick={resetTaskForm}
      style={{
        background: '#777',
        color: 'white'
      }}
    >
      Cancel Edit
    </button>
  )}
</div>
    </>
  );
}

export default TaskForm;